import { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Tab, Tabs } from '@material-ui/core';
import { withStyles, withTheme } from '@material-ui/core/styles';
import navTabsStyle from 'assets/jss/material-dashboard-pro-react/components/navTabsStyle';

const NavTabs = ({
  classes,
  tabs,
  changeTabOnMount,
  contentAfterTabButtons,
  title,
  disabled = false,
  onChange,
}) => {
  const timeoutId = useRef(0);
  const [active, setActive] = useState(0);
  const history = useHistory();
  useEffect(() => {
    if (changeTabOnMount && changeTabOnMount.bool) {
      timeoutId.current = setTimeout(() => {
        setActive(changeTabOnMount.index);
      }, changeTabOnMount.timeout);
    }

    return () => {
      clearTimeout(timeoutId.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, []);

  useEffect(() => {
    if (tabs[active]?.disabled) {
      setActive(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, [tabs]);

  const handleChange = (_, activeIndex) => {
    if (activeIndex === active) {
      return;
    }
    setActive(activeIndex);
    if (onChange) {
      onChange(_, activeIndex);
    }
    if (tabs[activeIndex].href) {
      history.replace(tabs[activeIndex].href);
    }
  };

  return (
    <>
      {title && <h3 className={classes.tabsTitle}>{title}</h3>}
      <div className={classes.tabsWrapper}>
        <Tabs
          classes={{
            root: classes.root,
            fixed: classes.fixed,
            flexContainer: classes.flexContainer,
            indicator: classes.displayNone,
          }}
          value={active}
          onChange={handleChange}
        >
          {tabs.map((prop, key) => (
            <Tab
              disabled={disabled || prop.disabled}
              label={prop.tabButton}
              key={key}
              classes={{
                root: classes.tabs,
                labelContainer: classes.labelContainer,
                label: classes.label,
                selected: classes.selected,
              }}
            />
          ))}
        </Tabs>
        {contentAfterTabButtons}
      </div>
      <div className={classes.contentWrapper}>
        {tabs.map((prop, key) => {
          if (key !== active) {
            return null;
          }
          return (
            <div className={classes.tabContent} key={key}>
              {prop.tabContent}
            </div>
          );
        })}
      </div>
    </>
  );
};

NavTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      tabButton: PropTypes.string,
      tabContent: PropTypes.node,
      disabled: PropTypes.bool,
    })
  ).isRequired,
  changeTabOnMount: PropTypes.shape({
    bool: PropTypes.bool,
    index: PropTypes.number,
    timeout: PropTypes.number,
  }),
  title: PropTypes.string,
};

export default withTheme()(withStyles(navTabsStyle)(NavTabs));
